export class ProcessOrderModel {
  constructor() {
    this.deliveryMode = '';
    this.dispatchType = '';
  }
}

export class CourierDeliveryModel {
  constructor() {
    this.serviceProvider = 'DTDC';
    this.trackingId = '';
    this.notes = '';
  }
}

export class HandDeliveryModel {
  constructor() {
    this.location = '';
    this.notes = '';
  }
}

export class InPersonPickupModel {
  constructor() {
    this.registeredStudent = new InPersonPickupRegisteredStudentModel();
    this.otherStudent = new InPersonPickupOtherStudentModel();
  }
}

export class InPersonPickupRegisteredStudentModel {
  constructor() {
    this.recipientType = '';
    this.notes = '';
  }
}

export class InPersonPickupOtherStudentModel {
  constructor() {
    this.recipientType = '';
    this.recipientName = '';
    this.recipientPhoneNumber = '';
    this.notes = '';
  }
}

export class InPersonPickupCommonModel {
  constructor() {
    this.recipientType = 'REGISTERED_STUDENT';
    this.recipientName = '';
    this.recipientPhoneNumber = '';
    this.notes = '';
  }
}

export class AddressModel {
  constructor() {
    this.type = 'HOME';
    this.addressLine1 = '';
    this.addressLine2 = '';
    this.landMark = '';
    this.city = '';
    this.state = '';
    this.pin = '';
    this.preferredAddress = false;
  }
}

/* API Models */
export class DeliveryModeCourierApiModel {
  constructor() {
    this.deliveryMode = 'COURIER';
    this.deliveryTrackerList = [];
    this.inHandDeliveryDetails = null;
    this.inPersonPickup = null;
    this.deliveryStatus = null;
  }
}

export class DeliveryTrackerListApiModel {
  constructor() {
    this.serviceProvider = '';
    this.trackingId = '';
    this.notes = '';
    this.status = '';
    this.trackerLink = '';
    this.state = '';
  }
}

export class DeliveryModeInPersonApiModel {
  constructor() {
    this.deliveryMode = 'IN_PERSON';
    this.deliveryTrackerList = null;
    this.inHandDeliveryDetails = null;
    this.inPersonPickup = new InPersonDetailsApiModel();
    // this.deliveryDateTime = null;
    this.deliveryStatus = null;
    this.state = '';
  }
}

export class InPersonDetailsApiModel {
  constructor() {
    this.recipientType = '';
    this.recipientName = '';
    this.recipientContactNo = '';
    this.inPersonPickupNotes = '';
  }
}

export class DeliveryModeInHandApiModel {
  constructor() {
    this.deliveryMode = 'IN_HAND';
    this.deliveryTrackerList = null;
    this.inHandDeliveryDetails = new HandDeliveryDetailsApiModel();
    this.inPersonPickup = null;
    // this.deliveryDateTime = null;
    this.deliveryStatus = null;
    this.state = '';
  }
}

export class HandDeliveryDetailsApiModel {
  constructor() {
    this.handDeliveryLocation = '';
    this.handDeliveryNotes = '';
  }
}

export class CancellationDetailsApiModel {
  constructor() {
    this.cancellationRequestType = '';
    this.description = '';
  }
}
